import { css } from "@emotion/react";
import styled from "@emotion/styled";
import publicIp from "public-ip";
import React, { useEffect, useState } from "react";
import { MOBILE_WIDTH } from "../../../../utils/HelperStyles";
import StyledButton from "../../../StyledButton";
import { StyledRadio } from "../../../StyledRadio";
import { useModal } from "../../Modal";
import { Checkbox } from "@chakra-ui/react";

const styledModalScrollbar = css`
  /* ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: #dcdfe3;
  }

  ::-webkit-scrollbar-thumb {
    background: #848688;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555b5f;
  } */
`;

const ModalContainer = styled.div`
  height: 74vh;
  width: 56vw;
  display: flex;
  flex-direction: column;

  position: relative;

  .scroll-flag {
    position: absolute;
    top: -26px;
    left: -28px;
  }

  > div {
    margin-left: -20px;
  }

  @media (max-width: ${MOBILE_WIDTH}) {
    width: 100vw;
    height: 100vh;
    padding-bottom: 150px;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;

  font: normal normal normal 18px/39px Lato;
  color: #8f9193;

  width: 100%;

  padding-bottom: 20px;
  border-bottom: 1px solid #eceeef;
`;

const ClickHereButton = styled.a`
  color: #6a6a6a;
  font-size: 15px;
  :hover {
    color: #fb972e;
  }
`;

const FollowingContent = styled.div`
  text-align: left;
  font: normal normal normal 20px/25px Lato;
  letter-spacing: 0px;
  color: #111111;

  padding-top: 25px;

  > ul {
    list-style-type: none;
  }
`;

const Acknowledge = styled.div`
  display: flex;
  flex-direction: column;

  padding: 20px 20px;
  border-radius: 8px;

  background-color: #fff0e0;

  text-align: left;
  font: normal normal normal 16px/25px Lato;
  color: #111111;

  margin-top: 10px;
  margin-bottom: 10px;
`;

const Address = styled.div`
  display: flex;
  flex-direction: column;

  padding: 20px 20px;
  border-radius: 8px;

  background-color: #f7f7f7;

  text-align: left;
  font: normal normal normal 16px/25px Lato;
  color: #111111;

  margin-top: 10px;
  margin-bottom: 10px;
`;

const FollowingWrapper = styled.div`
  display: flex;
  flex-direction: column;

  overflow-y: auto;

  ${styledModalScrollbar}

  padding-right: 50px;
  padding-left: 50px;
`;

const Title = styled.div`
  font: normal normal 900 30px/36px "Source Sans Pro";
  text-align: center;
  margin-bottom: 10px;
`;

const Subtitle = styled.div`
  font: normal normal 900 16px/21px "Source Sans Pro";
  text-align: center;

  :not(:first-child) {
    margin-top: 15px;
    margin-bottom: 10px;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
`;

const SubItem = styled.div`
  font: normal normal 700 16px/22px Poppins;
  text-align: center;
`;

const CustomLink = styled.a`
  color: #15c;

  :visited {
    color: #15c;
  }
  :focus {
    color: #15c;
  }
`;

interface ITermsAndServices {
  onOkClick: () => void;
}

export default function TermsAndServices(
  props: ITermsAndServices
): JSX.Element {
  const { onOkClick } = props;

  const modal = useModal();
  const [readCheck, setReadCheck] = useState<boolean>(false);
  const [allowCheck, setAllowCheck] = useState<boolean>(false);
  const [noRefundCheck, setNoRefundCheck] = useState<boolean>(false);

  const [ipAdrress, setIpAdrress] = useState("");

  useEffect(() => {
    (async () => {
      const ip = await publicIp.v4();
      setIpAdrress(ip);
    })();
  }, []);

  return (
    <ModalContainer>
      <img
        className="scroll-flag"
        src="/images/scroll-modal.png"
        alt="Scroll"
      />
      <FollowingWrapper>
        <HeaderContainer>
          Please note that your IP address{" "}
          {ipAdrress !== "" && `(${ipAdrress}) `}will be captured and your
          answers will be logged.
        </HeaderContainer>
        <FollowingContent>
          <Title>Legal & Policies</Title>
          <p>
            This website legal document was last updated on September 5th, 2021.
          </p>
          <p>
            Thank you for visiting BerserkerMail.com (hereinafter referred to as
            "Website," "website," or "Site”). The Website is owned by the
            Learnistic LLC, a Florida limited liability company (the “Company”).
          </p>
          <p>
            This web page contains the following legal documents and policies
            for our Website:
          </p>
          <p>1. Financial Disclaimers</p>
          <p>2. Terms and Conditions of Use</p>
          <p>3. Non-Discrimination Policy</p>
          <p>4. Other Disclaimers and Limitations of Liability</p>
          <p>5. Electronic Communications Policy</p>
          <p>6. Material Connections and Compensation Disclosure Policy</p>
          <p>7. External Links Policy</p>
          <p>8. Accessibility Policy</p>
          <p>9. Miscellaneous Provisions</p>
          <p>10. Digital Millennium Copyright Act ("DMCA") Notice</p>
          <p>11. Privacy Policy</p>
          <p>12. Refunds {"&"} Subscription Cancellations Policy</p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>1. FINANCIAL DISCLAIMERS</span>
          </h2>
          <p>
            You understand and agree that there are important risk factors that
            should be considered by you when deciding whether to purchase a
            subscription to the Learnistic mobile and desktop software
            applications (individually and collectively, the “Learnistic
            Applications”) for your business. The following disclaimers apply to
            the extent our Website, products or services, and/or our
            communications with you refer to income, earnings, or other
            financial matters.
          </p>
          <p>
            No Earnings Projections, Promises or Representations You recognize
            and agree that we have made no implications, warranties, promises,
            suggestions, projections, representations or guarantees whatsoever
            to you about future prospects or earnings, or that you or your
            business will earn any money, with respect to your purchase of a
            subscription to the Learnistic Applications, and that we have not
            authorized any such projection, promise, or representation by
            others.
          </p>
          <p>
            Any earnings or income statements, or any earnings or income
            examples, are only estimates of what we think a business or its
            owners could earn. There is no assurance you or your business will
            do as well as stated in any examples. If you rely upon any figures
            provided, you must accept the entire risk of not doing as well as
            the information provided. This applies whether the earnings or
            income examples are monetary in nature or pertain to advertising
            credits which may be earned (whether such credits are convertible to
            cash or not.
          </p>
          <p>
            There is no assurance that any prior successes or past results as to
            earnings or income (whether monetary or advertising credits, whether
            convertible to cash or not) will apply, nor can any prior successes
            be used, as an indication of your future success or results from use
            of the Learnistic Applications or any of the information, content,
            or strategies provided at our website and in our communications with
            you. Any and all claims or representations as to income or earnings
            (whether monetary or advertising credits, whether convertible to
            cash or not) are not to be considered as "average earnings".
          </p>
          <h3>
            <span>The Economy</span>
          </h3>
          <p>
            The economy, both where you do business, and on a national and even
            worldwide scale, creates additional uncertainty and economic risk.
            An economic recession or depression might negatively affect the
            results produced by your use of the Learnistic Applications.
          </p>
          <h3>
            <span>Your Success or Lack of It</span>
          </h3>
          <p>
            Your success in using the Learnistic Applications, the information,
            strategies and tactics provided at our Website and in our
            communications with you depends upon a variety of factors. We have
            no way of knowing how well you will do, as we do not know you, your
            background, your work ethic, your dedication, your motivation, your
            desire, or your business skills or practices. Therefore, we do not
            guarantee or imply that you will get rich, that you will do as well,
            or that you or your business will have any earnings (whether
            monetary or advertising credits, whether convertible to cash or not)
            at all.
          </p>
          <p>
            Business ventures and earnings derived therefrom involve unknown
            risks and are not suitable for everyone. You may not rely on any
            information presented on the Website or otherwise provided by us,
            unless you do so with the knowledge and understanding that you and
            your business can experience significant losses, including, but not
            limited to, the loss of any monies paid to subscribe to the
            Learnistic Applications, and/or any monies spent setting up,
            operating, and/or marketing courses and other content within the
            Learnistic Applications
          </p>
          <h2>
            <span>Forward-Looking Statements</span>
          </h2>
          <p>
            MATERIALS CONTAINED ON THIS WEBSITE, DOWNLOADED FROM THIS WEBSITE
            CONTAINED IN THE THE LEARNISTIC APPLICATIONS, AND/OR OUR
            COMMUNICATIONS WITH YOU MAY CONTAIN INFORMATION THAT INCLUDES OR IS
            BASED UPON FORWARD-LOOKING STATEMENTS WITHIN THE MEANING OF THE
            SECURITIES LITIGATION REFORM ACT OF 1995. FORWARD-LOOKING STATEMENTS
            GIVE OUR EXPECTATIONS OR FORECASTS OF FUTURE EVENTS. YOU CAN
            IDENTIFY THESE STATEMENTS BY THE FACT THAT THEY DO NOT RELATE
            STRICTLY TO HISTORICAL OR CURRENT FACTS. THEY USE WORDS SUCH AS
            "ANTICIPATE," "ESTIMATE," "EXPECT," "PROJECT," "INTEND," "PLAN,"
            "BELIEVE," AND OTHER WORDS AND TERMS OF SIMILAR MEANING IN
            CONNECTION WITH A DESCRIPTION OF POTENTIAL EARNINGS OR FINANCIAL
            PERFORMANCE.
          </p>
          <p>
            ANY AND ALL FORWARD-LOOKING STATEMENTS HERE, IN OTHER MATERIALS
            CONTAINED ON THIS WEBSITE OR IN MATERIALS PURCHASED, IN THE
            LEARNISTIC APPLICATIONS, AND/OR OUR COMMUNICATIONS WITH YOU ARE
            INTENDED TO EXPRESS OUR OPINION OF EARNINGS POTENTIAL. MANY FACTORS
            WILL BE IMPORTANT IN DETERMINING YOUR ACTUAL RESULTS AND NO
            GUARANTEES ARE MADE THAT YOU WILL ACHIEVE RESULTS SIMILAR TO OURS OR
            ANYBODY ELSE, IN FACT NO GUARANTEES ARE MADE THAT YOU WILL ACHIEVE
            ANY RESULTS FROM OUR IDEAS, STRATEGIES, AND TACTICS.
          </p>
          <h3>
            <span>Due Diligence</span>
          </h3>
          <p>
            You are advised to do your own due diligence when it comes to making
            business decisions and should use caution and seek the advice of
            qualified professionals. You should check with your accountant,
            lawyer, or professional advisor, before acting on this or any
            information. You may not consider any examples, documents, other
            content on the Website, content within the Learnistic Applications,
            our communications with you, or information otherwise provided by us
            to be the equivalent of professional advice. We do not provide
            professional advice to you or your business in any way. You should
            consult with your own accountant, lawyer, or professional advisor
            for any questions you may have.
          </p>
          <p>
            We assume no responsibility for any losses or damages resulting from
            your use of any link, information, or opportunity contained within
            the Website, the Learnistic Applications, or within any other
            information disclosed by the Company in any form whatsoever.
          </p>
          <h3>
            <span>Purchase Price</span>
          </h3>
          <p>
            Although we believe the Learnistic Applications’ subscription price
            is fair for the value that you and your business receive, you
            understand and agree that the pricing has been arbitrarily set by
            us. These prices bear no relationship to objective standards.
          </p>
          <h3>
            <span>Accuracy and Completeness</span>
          </h3>
          <p>
            Facts and information are believed to be accurate at the time they
            were placed on this Website and within the Learnistic Applications.
            All data provided at this Website and within the Learnistic
            Applications is to be used for informational purposes only. The
            Learnistic Applications and related products and services are only
            offered in jurisdictions where they may be legally offered.
            Information provided is not all-inclusive, and is limited to
            available information, and such information should not be relied
            upon as all-inclusive or accurate.
          </p>
          <h3>
            <span>Injuries</span>
          </h3>
          <p>
            You agree to hold the Company, its owners, agents, and employees
            harmless from any and all liability for all claims for damages due
            to injuries, including attorney fees and costs, incurred by you or
            your business or caused to third parties by you or your business,
            arising out of the Learnistic Applications, related products and
            services, Website content, and our communications with you,
            excepting only claims for gross negligence or intentional tort.
          </p>
          <h3>
            <span>Testimonials, Case Studies, and Examples</span>
          </h3>
          <p>
            Testimonials, case studies, and examples found at this Website are
            exceptional results, do not reflect the typical Learnistic
            subscriber’s experience, don't apply to the average person or
            business, and are not intended to represent or guarantee anyone will
            achieve the same or similar results. If we have disclosed typical
            results based on information provided to us by a manufacturer or
            other reputable third-party source, you should presume the typical
            results as stated are more reliable than the testimonials, case
            studies, and examples found at this Website.
          </p>
          <p>
            However, you should always perform due diligence and not take such
            results at face value. We are not responsible for any errors or
            omissions in typical results information supplied to us by
            manufacturers, service providers, or other reputable third parties.
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>

          <h2>
            <span>2. TERMS AND CONDITIONS OF USE</span>
          </h2>
          <p>
            If you want to view or use our Website or the Learnistic
            Applications, you must agree to conform to and be legally bound by
            the terms and conditions described below. If you disagree with any
            of these terms or conditions, do not use our Website or the
            Learnistic Applications.
          </p>
          <h3>
            <span>
              Our Website's Privacy Policy Is Part of These Terms and Conditions
            </span>
          </h3>
          <p>
            Our website's Privacy Policy is part of, and subject to, these Terms
            and Conditions of Use. You may view our Privacy Policy elsewhere on
            our Website. To the extent there is a conflict, these Terms and
            Conditions of Use shall govern.
          </p>
          <h3>
            <span>
              These Policies, Terms, Conditions, and Customer Agreements
            </span>
          </h3>
          <p>
            If you are a Learnistic customer, any customer agreement between us
            supersedes these policies, terms and conditions to the extent there
            is any conflict with the terms and conditions of the customer
            agreement.
          </p>
          <h3>
            <span>Video and Audio Content</span>
          </h3>
          <p>
            This Website and the Learnistic Applications may contain one or more
            videos and/or audio recordings (individually and collectively
            hereinafter referred to as the "Recordings"). This section describes
            our respective rights and responsibilities with regard to the
            Recordings.
          </p>
          <h3>
            <span>
              Recordings Are for Entertainment and Informational Purposes Only
            </span>
          </h3>
          <p>
            All Recordings are to be watched and/or listened to for
            informational and entertainment purposes only. Recordings are not
            intended to provide specific legal, financial, tax, physical or
            mental health advice, or any other advice whatsoever to you, any
            other individual or company, and should not be relied upon in that
            regard. Any products or services described in the Recordings are
            only offered in jurisdictions where they may be legally offered.
            Information provided in Recordings is not all-inclusive, is limited
            to information available, and such information should not be relied
            upon as all-inclusive or accurate.
          </p>
          <h3>
            <span>
              Embedded Recordings from External Social Media Sites Not Owned by
              Us
            </span>
          </h3>
          <p>
            Some of the Recordings embedded for your viewing and listening
            pleasure may be hosted on social media websites not owned by us.
            This may include, but is not limited to, sites such as YouTube.com,
            Vimeo.com, DailyMotion.com and the like (individually and
            collectively, the "Third Party Social Media Sites").
          </p>
          <p>
            We make no claim to the intellectual property rights of the owners
            of Third-Party Social Media Sites. We also make no claim to the
            intellectual property rights of third-party creators of Recordings
            hosted on Third Party Social Media Sites. Our embedding of such
            Recordings on this Website is done pursuant to applicable licenses
            to do so granted by the Third-Party Social Media Sites.
          </p>
          <p>
            Embedding Recordings on this Website does not create an association,
            agency, joint venture, or partnership between us and the owners of
            the Third-Party Social Media Sites or impose any liability
            attributable to such a relationship upon either party.
          </p>
          <p>
            Recordings are only provided for your convenience. We do not control
            or guarantee the accuracy, completeness, relevance, or timeliness of
            any information contained in the Recordings. You should know Third
            Party Social Media Sites may track your viewing and listening
            habits.
          </p>
          <p>
            If Recordings embedded on this Website were created by us but are
            hosted on Third Party Social Media Sites, we retain all intellectual
            property rights for such Recordings except to the extent we granted
            a license to Third Party Social Media Sites to the Recordings. The
            hosting of these Recordings by Third Party Social Media Sites does
            not grant you any rights to such Recordings except to the extent
            provided under the applicable licenses those sites grant to viewers
            and listeners of Recordings they host on their websites.
          </p>
          <h3>
            <span>
              Embedded Recordings Owned by Us and Hosted on Our Servers or
              Third-Party Servers Excluding Third Party Social Media Sites
            </span>
          </h3>
          <p>
            Some of the Recordings embedded for your viewing and listening
            pleasure may be created by us and hosted on our servers or
            third-party servers. This may include, but is not limited to cloud
            hosting services from Amazon Web Services (“AWS”), Google Cloud
            services, Microsoft Azure, or others but excludes the Third-Party
            Social Media Sites described above.
          </p>
          <p>
            We own the copyrights and all other intellectual property rights for
            these Recordings unless otherwise expressly noted. We make no claim
            to the intellectual property rights of the owners of third-party
            servers who by contractual agreement are hosting our Recordings for
            us.
          </p>
          <p>
            Hosting our Recordings on third party servers does not create an
            association, agency, joint venture, or partnership between us and
            the owners of those servers, or impose any liability attributable to
            such a relationship upon either party.
          </p>
          <p>
            Recordings are only provided for your convenience. We do not
            guarantee the accuracy, completeness, relevance, or timeliness of
            any information contained in the Recordings. You should know we
            and/or the owners of third-party servers hosting the Recordings may
            track your viewing and/or listening habits.
          </p>
          <h3>
            <span>
              Personal Non-Exclusive Revocable Nontransferable License
            </span>
          </h3>
          <p>
            When you watch or listen to the Recordings on this Website, you
            understand and agree you are doing so pursuant to a personal
            non-exclusive revocable nontransferable license from us to do so.
          </p>
          <p>
            The Recordings remain the sole and exclusive property of their
            respective owners, which retain all rights thereto. You understand
            and agree the Recordings may not be resold by you or otherwise
            distributed with or without consideration. You will not make the
            Recordings available to any third party. You may not reproduce or
            summarize any of the Recordings in any manner.
          </p>
          <p>
            You agree to destroy any of the Recordings cached on your computer,
            tablet, smart phone, or otherwise in your possession within
            twenty-four (24) hours of watching or listening to said Recordings.
            Notwithstanding this provision, you agree to immediately destroy any
            Recordings in your possession upon material violation of the terms
            and conditions contained in this document, or upon request by us
            that you do so.
          </p>
          <h3>
            <span>Broken or Obsolete Recordings</span>
          </h3>
          <p>
            We review our Website periodically for broken or out-of-date
            Recordings. Any and all Recordings may be posted, altered, or
            removed at any time. To report problems with Recordings on our
            Website, or for more information, please send an email to
            help[at]learnistic.com or by using the contact form at{" "}
            <CustomLink
              href="https://berserkermail.com/contact.html"
              target="_blank"
            >
              https://berserkermail.com/contact.html
            </CustomLink>
            .
          </p>
          <h3>
            <span>Licensee Status</span>
          </h3>
          <p>
            You understand and agree your use of our Website is limited and
            non-exclusive as an individual nontransferable revocable licensee.
            We may, within our sole discretion, terminate your license to use
            our Website, and access to our Website, for any reason or no reason
            whatsoever, and without giving you notice. Your use (if any) of the
            Learnistic Applications are governed by your subscription agreement
            with us.
          </p>
          <h3>
            <span>Content Ownership</span>
          </h3>
          <p>
            All content on our Website is owned by us or our content suppliers.
            On behalf of ourselves and our content suppliers, we claim all
            property rights, including intellectual property rights, for this
            content, and you are not allowed to infringe upon those rights. We
            will prosecute to the fullest extent of the law anyone who attempts
            to steal our property.
          </p>
          <p>
            You agree not to copy content from our Website without our
            permission. Any requests to use our content should be submitted to
            us by email to help[at]learnistic.com or by using the contact form
            at{" "}
            <CustomLink
              href="https://berserkermail.com/contact.html"
              target="_blank"
            >
              https://berserkermail.com/contact.html
            </CustomLink>
            .
          </p>
          <p>
            This website legal document is Copyright © 2008-2021 Law Office of
            Michael E. Young PLLC and licensed for use by the Company at
            Learnistic.com. All Rights Reserved. No portion of this document may
            be copied or used by anyone other than the Company without the
            express written permission of the law firm as copyright owner.
          </p>
          <p>
            If you believe your intellectual property rights have been infringed
            upon by our Website content, please notify us by sending an email to
            help[at]learnistic.com or by using the contact form at{" "}
            <CustomLink
              href="https://berserkermail.com/contact.html"
              target="_blank"
            >
              https://berserkermail.com/contact.html
            </CustomLink>
            , or by sending first class postal mail to us at the address listed
            below. Please describe in detail the alleged infringement, including
            the factual and legal basis for your claim of ownership.
          </p>
          <p>
            For copyright infringement issues, please follow the instructions in
            the DMCA Notice found below on this web page.
          </p>
          <h3>
            <span>Competing Products & Services</span>
          </h3>
          <p>
            You shall not use our Website to promote products or services that
            directly or indirectly compete with the Learnistic Applications.
            Violation of this provision, as determined in our sole discretion,
            shall result in (a) a permanent ban of your use of our Website and
            the Learnistic Applications, and (b) we will not knowingly sell you
            any products or services in the future.
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>3. NON-DISCRIMINATION POLICY</span>
          </h2>
          <p>
            The Company, its principals, employees, independent contractors, and
            agents do not discriminate on the basis of race, color, national
            origin, citizenship status, ethnic origin, ancestry, age, religion,
            religious creed, physical or mental disability, handicap, sex,
            gender, gender identity, gender expression, sexual orientation,
            marital status, military status, veteran status, or any other
            characteristic protected under applicable law.
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>4. DISCLAIMERS AND LIMITATIONS OF LIABILITY</span>
          </h2>
          <p>
            THE INFORMATION ON OUR WEBSITE IS PROVIDED ON AN "AS IS," "AS
            AVAILABLE" BASIS. YOU AGREE YOUR USE OF OUR WEBSITE IS AT YOUR SOLE
            RISK. WE DISCLAIM ALL WARRANTIES OF ANY KIND, INCLUDING BUT NOT
            LIMITED TO, ANY EXPRESS WARRANTIES, STATUTORY WARRANTIES, AND ANY
            IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT OUR WEBSITE WILL
            ALWAYS BE AVAILABLE, ACCESS WILL BE UNINTERRUPTED, BE ERROR-FREE,
            MEET YOUR REQUIREMENTS, OR THAT ANY DEFECTS IN OUR WEBSITE WILL BE
            CORRECTED. INFORMATION ON OUR WEBSITE SHOULD NOT NECESSARILY BE
            RELIED UPON AND SHOULD NEVER BE CONSTRUED TO BE PROFESSIONAL ADVICE
            FROM US. WE DO NOT GUARANTEE THE ACCURACY OR COMPLETENESS OF ANY OF
            THE INFORMATION PROVIDED, AND ARE NOT RESPONSIBLE FOR ANY LOSS
            RESULTING FROM YOUR RELIANCE ON SUCH INFORMATION. IF YOUR
            JURISDICTION DOES NOT ALLOW LIMITATIONS ON WARRANTIES, THIS
            LIMITATION MAY NOT APPLY TO YOU. YOUR SOLE AND EXCLUSIVE REMEDY
            RELATING TO YOUR USE OF THE SITE SHALL BE TO DISCONTINUE USING THE
            SITE. UNDER NO CIRCUMSTANCES WILL WE BE LIABLE OR RESPONSIBLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL (INCLUDING DAMAGES
            FROM LOSS OF BUSINESS, LOST PROFITS, LITIGATION, OR THE LIKE),
            SPECIAL, EXEMPLARY, PUNITIVE, OR OTHER DAMAGES, UNDER ANY LEGAL
            THEORY, ARISING OUT OF OR IN ANY WAY RELATING TO OUR WEBSITE, YOUR
            WEBSITE USE, OR THE CONTENT, EVEN IF ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGES. OUR TOTAL LIABILITY FOR ANY CLAIM ARISING OUT OF OR
            RELATING TO OUR WEBSITE SHALL NOT EXCEED ONE HUNDRED ($100) DOLLARS
            AND THAT AMOUNT SHALL BE IN LIEU OF ALL OTHER REMEDIES THAT YOU MAY
            HAVE AGAINST US OR OUR AFFILIATES (IF ANY). ANY SUCH CLAIM SHALL BE
            SUBJECT TO CONFIDENTIAL BINDING ARBITRATION AS DESCRIBED LATER IN
            THIS DOCUMENT.
          </p>
          <h3>
            <span>Cyber-Bullying and Internet Harassment</span>
          </h3>
          <p>
            Cyber-bullying and Internet harassment are prohibited. Although we
            support First Amendment free speech rights, such rights are limited
            where the purpose or effect of the expression is to bully, harass,
            threaten, ridicule, embarrass, and/or intimidate others. This is
            particularly true in matters involving race, ethnicity, national
            origin, religion, gender, gender identity or expression, sex, sexual
            orientation, physical disability, and/or mental condition.
          </p>
          <p>
            If we decide, in our sole discretion, you have committed
            cyber-bullying acts or Internet harassment, we reserve the right to
            unilaterally suspend or ban your use of our Website immediately with
            or without notice to you. Although we are not obligated to do so, we
            reserve the right to monitor, investigate, and remove material
            posted to our Website we determine constitutes cyber-bullying or
            Internet harassment.
          </p>
          <p>
            If we suspect the cyber-bullying acts or Internet harassment
            constitutes illegal activity, we may, in our sole discretion,
            provide information to law enforcement or other government officials
            for purposes of investigating the misconduct. Examples of illegal
            conduct include, but are not limited to, threats of violence,
            sending sexually explicit images, and stalking others. This sharing
            of information is consistent with our Website’s Privacy Policy terms
            governing suspected illegal activity.
          </p>
          <h3>
            <span>Obscene and Harassing Content</span>
          </h3>
          <p>
            We are not prudes. This means you may see salty language on our
            Website or in the Learnistic Applications like you would find in an
            R-rated movie. Remember that both the Website and the Learnistic
            Applications are intended solely for use by adults (no minors).
          </p>
          <p>
            However, we are not responsible for any obscene or harassing content
            you receive or view from others while using our Website or the
            Learnistic Applications. If you do receive or view such content,
            please contact us by email to help[at]learnistic.com or by using the
            contact form at https://learnistic.com/contact so we can investigate
            the matter. Although we are not obligated to do so, we reserve the
            right to monitor, investigate, and remove obscene or harassing
            material posted to our Website or the Learnistic Applications.
          </p>
          <h3>
            <span>
              Business Opportunities &amp; Seller Assisted Marketing Plans
            </span>
          </h3>
          <p>
            Without our express prior written permission, you shall not use our
            Website or the Learnistic Applications to promote, market, or
            advertise directly or indirectly on behalf of any “business
            opportunity” covered by the U.S. Federal Trade Commission’s Business
            Opportunity Rule, 16 C.F.R. § 437.1 et seq. (as amended) or any
            “seller assisted marketing plan” covered by the California Seller
            Assisted Marketing Plan Act, Cal. Civ. Code §§ 1812.200-1812.221.
            This includes, but is not limited to, comments, messages, and
            signature tag lines promoting a business opportunity. If you violate
            this provision, as determined in our sole discretion, we reserve the
            right to unilaterally suspend or ban your use of our Website and the
            Learnistic Applications immediately with or without notice to you,
            and to remove all offending content from our Website and the
            Learnistic Applications.
          </p>
          <h3>
            <span>Indemnification</span>
          </h3>
          <p>
            You understand and agree you will indemnify, defend and hold us and
            our affiliates (if any) harmless from any liability, loss, claim and
            expense, including reasonable attorney's fees, arising from your use
            of our Website or your violation of these terms, conditions, and
            policies.
          </p>
          <h3>
            <span>Compliance with Governing Law and Dispute Resolution</span>
          </h3>
          <p>You agree to obey all applicable laws while using our Website.</p>
          <h3>
            <span>Applicable Law</span>
          </h3>
          <p>
            You agree the laws of the State of Florida and the federal
            government of the United States of America govern these terms and
            conditions of use without regard to conflicts of laws provisions.
          </p>
          <h3>
            <span>California Residents</span>
          </h3>
          <p>
            If you reside in the State of California, you understand and agree
            that the State of Florida’s laws and United States federal laws
            govern these terms and conditions, taking precedence over any rights
            you might otherwise have under the California Consumer Privacy Act
            of 2018, Cal. Civ. Code § 1798.100 to § 1798.199 ("CCPA"). Any CCPA
            rights you may have are ancillary and subservient to the laws of the
            State of Florida and the United States.
          </p>
          <h3>
            <span>European Union Residents</span>
          </h3>
          <p>
            If you reside in the European Union, you understand and agree that
            the State of Florida’s laws and United States federal laws govern
            these terms and conditions, taking precedence over any rights you
            might otherwise have under Regulation (EU) 2016/679, the General
            Data Protection Regulation ("GDPR"). Any GDPR rights you may have
            are ancillary and subservient to the laws of the State of Florida
            and the United States.
          </p>
          <h3>
            <span>Brazil Residents</span>
          </h3>
          <p>
            If you reside in the Federal Republic of Brazil, you understand and
            agree that the State of Florida’s laws and United States federal
            laws govern these terms and conditions, taking precedence over any
            rights you might otherwise have under Brazilian General Data
            Protection Law (“LGPD”), Fed. Law No. 13,709/2018. Any LGDP rights
            you may have are ancillary and subservient to the laws of the State
            of Florida and the United States.
          </p>
          <h3>
            <span>Arbitration of Disputes</span>
          </h3>
          <p>
            You also agree any dispute between you and us, excluding any
            intellectual property right infringement claims we pursue against
            you, shall be settled solely by confidential binding arbitration per
            the American Arbitration Association commercial arbitration rules.
            All claims must be arbitrated on an individual basis, and cannot be
            consolidated in any arbitration with any claim or controversy of
            anyone else. All arbitration must occur in Orange County, Florida,
            United States. Each party shall bear one half of the arbitration
            fees and costs incurred, and each party is responsible for its own
            lawyer fees.
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>5. ELECTRONIC COMMUNICATIONS POLICY</span>
          </h2>
          <p>
            We hate unsolicited commercial email (“UCE”) as much as you do. Also
            known as spam or junk email, UCE is a disservice to the Internet
            community.
          </p>
          <p>
            We fully endorse and comply with the requirements of the CAN-SPAM
            Act of 2003 (Controlling the Assault of Non-Solicited Pornography
            and Marketing Act), and all other applicable unsolicited commercial
            email laws. For example, California’s anti-spam law, Cal. Bus. &
            Prof. Code § 17529, may apply if you are using or sending to a
            California electronic mail address, and in other limited
            circumstances.
          </p>
          <h3>
            <span>E-Newsletters & Other Optional Communications</span>
          </h3>
          <p>
            If you subscribe to electronic newsletters or other communications
            from us or our Website, you will always have an option to
            unsubscribe immediately.
          </p>
          <h3>
            <span>Customer-Specific Communications</span>
          </h3>
          <p>
            If you are a current or former subscriber to the Learnistic
            Applications, you may receive emails or other electronic
            communications from us regarding your purchase(s). As a customer,
            you should not unsubscribe, block, filter, or otherwise prevent
            receipt of these important messages relating to your purchase(s) and
            your use of the Learnistic Applications.
          </p>
          <h3>
            <span>Consent to Respond</span>
          </h3>
          <p>
            When you communicate with us by email, text message, telephone call,
            or other electronic means, you are agreeing we can respond to you by
            the same or other electronic means of communication. You also agree
            we can subsequently communicate with you for marketing and other
            commercial purposes by electronic means using the information you
            have provided to us (email address, mobile phone number, etc.)
            unless and until you make a signed written request by email or by
            mail to our address listed below that these subsequent
            communications cease. Your request must include the specific contact
            information you no longer wish us to use for communicating with you
            (email address, mobile phone number, etc.)
          </p>
          <h3>
            <span>Questions or Comments About This Policy</span>
          </h3>
          <p>
            If you have additional questions, comments or concerns, please
            contact us by sending an email to help[at]learnistic.com or by using
            the contact form at https://learnistic.com/contact and providing us
            with information relating to your concern.
          </p>
          <p>You may also mail your concerns to us at the following address:</p>
          <Address>
            Learnistic LLC <br />
            13506 Summerport Village Parkway #714 <br />
            Windermere, FL 34786 <br />
            United States
          </Address>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>
              6. MATERIAL CONNECTIONS AND COMPENSATION DISCLOSURE POLICY
            </span>
          </h2>
          <p>
            You should always conduct your own investigation (perform due
            diligence) before buying products or services from anyone via the
            internet. This includes products and services sold within the
            Learnistic Applications, on this Website, and all other websites.
          </p>
          <h3>
            <span>Material Connections</span>
          </h3>
          <p>
            Unless otherwise expressly stated, you should assume all references
            to products and services on this Website are made because material
            connections exist between the Company and the providers of the
            mentioned products and services ("Provider").
          </p>
          <h3>
            <span>Good Faith Recommendations</span>
          </h3>
          <p>
            The Company recommends products and services based in part on a good
            faith belief the purchase of such products or services will help
            purchasers in general. The Company has this good faith belief
            because (a) the Company has tried the product or service mentioned
            prior to recommending it or (b) the Company has researched the
            reputation of the Provider and has made the decision to recommend
            the Provider's products or services based on the Provider's history
            of providing these or other products or services. The
            representations made by the Company about products and services
            reflect the Company's honest opinion based upon the facts known to
            the Company at the time a product or service is mentioned on this
            Website, in social media, and/or email communications.
          </p>
          <h3>
            <span>Potential Bias and Due Diligence</span>
          </h3>
          <p>
            The Company's opinion about a product or service may be partially
            formed (consciously or subconsciously) in part based on the fact the
            Company has been, may be, or will be compensated because of the
            Company's business relationships with the Providers.
          </p>
          <p>
            In some instances, the Company and a Provider will have a business
            or personal relationship that does not involve the Company receiving
            compensation related to products and services mentioned on this
            Website. However, the nature of the relationship is sufficient to
            establish a material connection between the Company and the
            Provider.
          </p>
          <p>
            Because there may be a material connection between the Company and
            Providers of products or services mentioned on this Website, you
            should always assume the Company may be biased because of the
            Company's relationship with a Provider and/or because the Company
            has received or will receive something of value from a Provider.
          </p>
          <p>
            Perform your own due diligence before purchasing a product or
            service mentioned on this Website (or any other website).
          </p>
          <h3>
            <span>Compensation</span>
          </h3>
          <p>
            The type of compensation received by the Company may vary. In some
            instances, the Company may receive complimentary products, services,
            or money from a Provider prior to mentioning the Provider's products
            or services on this Website.
          </p>
          <p>
            In other instances, the Company may receive a monetary commission or
            non-monetary compensation when you take action based on the content
            of this Website. This includes, but is not limited to, when you
            purchase a product or service from a Provider after clicking on an
            affiliate link on this Website.
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>7. EXTERNAL LINKS POLICY</span>
          </h2>
          <p>
            This Website may contain hypertext links to other websites and
            information created and maintained by other individuals and
            organizations. These links are only provided for your convenience.
            We do not control or guarantee the accuracy, completeness,
            relevance, or timeliness of any information or privacy policies
            posted on these linked websites. You should know these websites may
            track visitor viewing habits.
          </p>
          <p>
            Unless otherwise expressly stated by us, hyperlinks to particular
            items do not reflect their importance, and are not an endorsement of
            the individuals or organizations sponsoring the websites, the views
            expressed on the websites, or the products or services offered on
            the websites.
          </p>
          <p>
            We permit links to our Website if they do not imply an endorsement
            by, or affiliation with, our Website absent written consent. If we
            operate an affiliate program, our affiliates may link to our Website
            pursuant to the terms and conditions of our affiliate program
            agreement with them.
          </p>
          <p>
            We review our Website periodically for broken or out-of-date links.
            Any and all links may be posted, altered, or removed at any time.
            Please note links to external websites may expire over time. Such
            expiration is beyond our control. To report problems with links on
            our Website, or for more information about this policy, please send
            an email to help[at]learnistic.com or by using the contact form at{" "}
            <CustomLink
              href="https://berserkermail.com/contact.html"
              target="_blank"
            >
              https://berserkermail.com/contact.html
            </CustomLink>
            .
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>8. ACCESSIBILITY POLICY</span>
          </h2>
          <p>
            We are committed to taking reasonable steps to make this Website
            accessible to visitors with disabilities. If you need help using our
            Website, please email us at help[at]learnistic.com or by using the
            contact form at{" "}
            <CustomLink
              href="https://berserkermail.com/contact.html"
              target="_blank"
            >
              https://berserkermail.com/contact.html
            </CustomLink>
            .
          </p>
          <p>
            If you are visually-impaired, we recommend using text-to-speech
            software, such as Microsoft’s Narrator, Apple’s VoiceOver, and the
            KNFB Reader mobile application (available in Apple’s App Store and
            at Google Play), to enjoy our Website.
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>9. MISCELLANEOUS PROVISIONS</span>
          </h2>
          <h3>
            <span>Protecting Your Account</span>
          </h3>
          <p>
            We reserve the right to suspend or terminate your account for
            misuse.
          </p>
          <p>
            If you have an account with us, you are responsible for protecting
            your account’s usernames and passcodes to prevent misuse of your
            account by others that is unlawful or violates these terms and
            conditions of use.
          </p>
          <p>
            You are also responsible for the actions (including purchases made)
            of any users you add to your account. For example, if one of your
            authorized users (e.g. a virtual assistant) decides to use one of
            the Learnistic Applications’ pay-per-use features, you will be
            responsible for the cost of such purchase.
          </p>
          <h3>
            <span>Posted and Submitted Content</span>
          </h3>
          <p>
            If you post content on or submit content to our Website (e.g.
            photos, videos, customer reviews or testimonials, comments, etc.),
            you represent you have the legal right to share such content on our
            Website, the content is accurate, and it does not violate the law or
            these terms and conditions of use.
          </p>
          <p>
            We reserve the right to edit or delete content you post or submit.
            However, we are not liable or responsible for content you and others
            submit or post on our Website.
          </p>
          <p>
            By posting or submitting content to us, you grant us an irrevocable,
            non-exclusive, royalty-free, perpetual, transferable, and
            sublicensable right to use the content. This includes a global right
            for us to adapt, alter, display, distribute, publish, reproduce, and
            translate the content. We can also create derivative works from the
            content in all media types (e.g. print, audio, video, etc.). You
            also grant us the right to use your name and username in connection
            with such content.
          </p>
          <p>
            If claims are made against us because of the content you post or
            submit, you agree to indemnify and defend us against those claims at
            your sole expense.
          </p>
          <h3>
            <span>Agreement Between Us</span>
          </h3>
          <p>
            These terms, conditions, and policies are an agreement between us
            that does not expressly or implicitly create any third-party
            beneficiary rights.
          </p>
          <h3>
            <span>Severability of These Terms, Conditions, and Policies</span>
          </h3>
          <p>
            If any part of these terms, conditions, and policies are determined
            by a court of competent jurisdiction to be invalid or unenforceable,
            that part shall be limited or eliminated to the minimum extent
            necessary so the remainder of these terms and conditions are fully
            enforceable and legally binding.
          </p>
          <h3>
            <span>How to Contact Us</span>
          </h3>
          <p>
            Any questions or concerns about these terms, conditions, and
            policies should be brought to our attention by email to
            help[at]learnistic.com or by using the contact form at{" "}
            <CustomLink
              href="https://berserkermail.com/contact.html"
              target="_blank"
            >
              https://berserkermail.com/contact.html
            </CustomLink>
            , and providing us with information relating to your concern.
          </p>
          <p>You may also mail your concerns to us at the following address:</p>
          <Address>
            Learnistic LLC <br />
            13506 Summerport Village Parkway #714 <br />
            Windermere, FL 34786 <br />
            United States
          </Address>
          <p>
            If you want to serve us with a subpoena, you must serve it on us by
            mail at our address listed above or to our local resident agent if
            we have one in your state. To determine whether we have a resident
            agent in your jurisdiction, check your state’s Secretary of State’s
            website or contact that state official’s office. Subpoenas sent by
            electronic means (email, fax, text message, etc.) will be ignored.
            To expedite our response to your subpoena, be sure to send to the
            attention of “Subpoena Processing” and include complete and accurate
            information.
          </p>
          <h3>
            <span>Force Majeure</span>
          </h3>
          <p>
            We, our principals, employees, independent contractors, and agents
            shall not be liable for failure to perform any of our obligations
            under these terms and conditions during any period in which we
            cannot perform due to fire, earthquake, flood, or other natural
            disaster, epidemic, pandemic, explosion, casualty, war, terrorism,
            embargo, riot, civil disturbance, act of public enemy, act of God,
            or the intervention of any government authority, or similar cause
            beyond our control.
          </p>
          <h3>
            <span>Entire Agreement</span>
          </h3>
          <p>
            These terms and conditions, including the policies incorporated
            herein by express reference, constitute your entire agreement with
            us with respect to your use of our Website.
          </p>
          <h3>
            <span>Modifications and Termination</span>
          </h3>
          <p>
            The above terms, conditions, and policies may change from time to
            time. If such changes are made, they will be effective immediately,
            and we will notify you by a notice posted on our Website's home page
            that changes have been made. If you disagree with the changes made,
            you should not use our Website. By continuing to access our Website
            after changes are made to these terms, conditions, and policies, you
            are agreeing to be legally bound by the revised terms, conditions,
            and policies.
          </p>
          <p>
            We may terminate these terms, conditions, and policies for any
            reason and at any time without notice to you.
          </p>
          <p>
            If you are concerned about these terms, conditions, and policies,
            you should read them each time before you use our Website. Any
            questions or concerns should be brought to our attention by sending
            an email to help[at]learnistic.com or by using the contact form at{" "}
            <CustomLink
              href="https://berserkermail.com/contact.html"
              target="_blank"
            >
              https://berserkermail.com/contact.html
            </CustomLink>
            , and providing us with information relating to your concern.
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>10. Digital Millennium Copyright Act ("DMCA") Notice</span>
          </h2>
          <p>
            This notice is for informational purposes only. It is not intended
            as, nor should it be construed as, legal advice. If you believe your
            intellectual property rights have been infringed upon, or if a
            notice of infringement has been filed against you, you should
            immediately seek legal counsel.
          </p>
          <p>
            This Website, including all text, HTML, scripts, and images are
            copyrighted, owned, and/or licensed by the Company. All rights
            reserved.
          </p>
          <p>
            NO PART OF THIS WEBSITE MAY BE REPRODUCED OR TRANSMITTED IN ANY FORM
            OR BY ANY MEANS, MECHANICAL, ELECTRONIC, OR OTHERWISE, INCLUDING
            PHOTOCOPYING AND RECORDING, OR BY ANY INFORMATION STORAGE AND
            RETRIEVAL SYSTEM, OR TRANSMITTED BY EMAIL, OR USED IN ANY OTHER
            FASHION WITHOUT THE EXPRESS PRIOR WRITTEN PERMISSION OF THE WEBSITE
            OWNER.
          </p>
          <p>
            This, of course, excludes the downloading and temporary caching of
            this Website on a personal computer for the explicit purpose of
            viewing this Website, as well as any information clearly marked as
            reproducible. This copyright notice applies to everyone, including
            all visitors to this Website.
          </p>
          <h3>
            <span>DMCA Provisions</span>
          </h3>
          <p>
            The Digital Millennium Copyright Act of 1998, found at 17 U.S.C. §
            512 ("DMCA"), provides recourse for owners of copyrighted materials
            who believe their rights under United States copyright law have been
            infringed upon on the Internet.
          </p>
          <p>
            Under the DMCA, the bona fide owner of copyrighted materials who has
            a good faith belief their copyright has been infringed may contact
            not only the person or entity infringing on their copyright, but may
            also contact the designated agent of an Internet service provider to
            report alleged infringements of their protected works, when such
            alleged infringements appear on pages contained within the system of
            the Internet service provider ("ISP").
          </p>
          <p>
            The owners of this Website and the ISP are committed to complying
            with international trade law, international trade practices, all
            United States laws, including United States copyright law. Upon
            receipt of a properly filed complaint under the DMCA, the owner
            and/or the ISP of this Website will block access to the allegedly
            infringing material. The website owner and/or the ISP will forward a
            copy of the notification of claimed copyright infringement to the
            alleged infringer. Anyone who believes in good faith that a notice
            of copyright infringement has wrongfully been filed against them,
            may submit a counternotice to the website owner and/or the ISP.
          </p>
          <h3>
            <span>Notification of Claimed Copyright Infringement</span>
          </h3>
          <p>
            Please send DMCA notifications of claimed copyright infringement to:
          </p>
          <p>THE WEBSITE OWNER</p>
          <Address>
            Learnistic LLC
            <br />
            13506 Summerport Village Parkway #714 <br />
            Windermere, FL 34786
            <br />
            United States
          </Address>
          <p>THE INTERNET SERVICE PROVIDER (ISP)</p>
          <Address>
            Attn: David Gucker, DMCA Agent <br />
            319 Clematis Street Suite 900 <br />
            West Palm Beach, FL 33401 <br />
            732-566-1268 (fax) <br />
            Email: dmca@vultr.com
          </Address>
          <p>
            To file a notice of infringement with either the website owner or
            the ISP, you must provide a written communication that sets forth
            the items specified below. You will be liable for damages (including
            damages, costs, and attorneys' fees) if you materially misrepresent
            that the website or a web page is infringing your copyright.
            Accordingly, if you are not sure whether certain material of yours
            is protected by copyright laws, we suggest you first contact an
            attorney.
          </p>
          <p>
            To expedite our ability to process your request, please use the
            following format (including section numbers):
          </p>
          <p>
            1. Identify in sufficient detail the copyrighted work you believe
            has been infringed upon.
          </p>
          <p>
            2. Identify the material you claim is infringing the copyrighted
            work listed in item #1 above. (You must include the URL(s) (the
            location(s) of the page(s) that contains the allegedly infringing
            material and also include a description of the specific content
            which you claim is infringing on your copyright.)
          </p>
          <p>
            3. Provide information reasonably sufficient to permit the website
            owner to contact you (e-mail address and a phone number are required
            at a minimum).
          </p>
          <p>
            4. Include the following statement: "I swear, under penalty of
            perjury, that the information in the notification is accurate and I
            am the copyright owner or am authorized to act on behalf of the
            owner of an exclusive right that is allegedly infringed. I also
            affirm as the copyright owner, I have a good faith belief that use
            of the material in the manner complained of is not authorized by me,
            my agent, or the law."
          </p>
          <p>
            5. The signature of the copyright owner or a person authorized to
            act on behalf of the copyright owner. You may send your notice via
            email provided such notice includes a proper electronic signature.
            The signature or electronic signature must be that of the copyright
            owner, or a person authorized to act on behalf of the owner, of an
            exclusive copyright that has allegedly been infringed.
          </p>
          <p>
            For details on the information required for valid notification, see
            17 U.S.C. § 512(c)(3).
          </p>
          <h3>
            <span>Counter-Notification to Claimed Copyright Infringement</span>
          </h3>
          <p>
            If a notice of copyright infringement has been filed with the
            website owner and/or the ISP against you, the owner and/or the ISP
            will attempt to notify you and provide you with a copy of the notice
            of copyright infringement. If you have a good faith belief you have
            been wrongfully accused, you may file a counternotification with the
            website owner and/or the ISP. If the website owner and/or the ISP
            receives a valid counternotification, the DMCA provides the removed
            or blocked information will be restored or access re-enabled.
          </p>
          <p>
            The website owner and/or the ISP will replace the removed material
            and cease disabling access to it in not less than 10, nor more than
            14, business days following receipt of the counternotification,
            unless the website owner and/or ISP first receives notice from the
            complaining party that such complaining party has filed an action
            seeking a court order to restrain the alleged infringer from
            engaging in infringing activity relating to the material on this
            Website.
          </p>
          <p>
            Please be advised that United States copyright law provides
            substantial penalties for a false counternotice filed in response to
            a notice of copyright infringement. Accordingly, if you are not sure
            whether certain material of yours is protected by copyright laws, we
            suggest you first contact an attorney.
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>11. Privacy Policy</span>
          </h2>
          <p>
            You may view our Website's Privacy Policy at the following link:
          </p>
          <p>
            <CustomLink
              href="https://berserkermail.com/pp.html"
              target="_blank"
            >
              https://berserkermail.com/pp.html
            </CustomLink>
          </p>
          <div style={{ width: "100%", textAlign: "center" }}>— — —</div>
          <h2>
            <span>12. Refunds {"&"} Subscription Cancellations Policy</span>
          </h2>
          <p>
            Our Refunds & Subscription Cancellations Policy can also be found
            online at:
          </p>
          <p>
            <a
              href="https://berserkermail.com/cancellation.html"
              target="_blank"
            >
              https://berserkermail.com/cancellation.html
            </a>
          </p>

          <h3>
            <span>No Refunds</span>
          </h3>

          <p>THERE ARE NO REFUNDS. ALL SALES ARE FINAL. NO EXCEPTIONS.</p>

          <h3>
            <span>Subscription Cancellations</span>
          </h3>

          <p>
            If you want to cancel your BerserkerMail subscription, please use
            the information in the “Contacting Us” section below to make your
            cancellation request.
          </p>
          <p>
            When you cancel your BerserkerMail subscription, you will continue
            to receive your subscription benefits until the end of the current
            billing period.
          </p>
          <p>
            YOU WILL NOT RECEIVE A REFUND OF ANY PORTION OF THE SUBSCRIPTION
            FEES YOU PAID FOR THE CURRENT OR PRIOR BILLING PERIODS.
          </p>
          <p>
            Example: If we process cancellation of a monthly BerserkerMail
            subscription on March 20th, you will continue to receive the
            benefits of that subscription until March 31st and there will not be
            a refund of any part of the March monthly subscription fee. You will
            neither be billed for nor receive the benefits of the cancelled
            subscription after March.
          </p>
          <p>
            Do not wait until the end of a billing or subscription period to
            make a subscription cancellation request because such requests are
            typically processed within 2 to 3 business days after we receive
            them. Providing us with your account/subscription number (if you
            have one) may speed up the process of honoring your request.
          </p>
          <p>We will confirm your subscription has been cancelled by email.</p>
          <h3>
            <span>Billing Failure Cancellations</span>
          </h3>

          <p>
            We will attempt to bill your subscription to the primary card you
            have on file with us, however, if it fails we may bill any other
            valid credit card you have attached to your account.
          </p>
          <p>
            We will attempt to contact you via email and via SMS to your primary
            account phone for a period of six (6) calendar days. If you do not
            fix the billing issue (by providing us with a valid credit card) and
            bring your account current during those six (6) days, your account
            will be cancelled on the seventh (7th) day. We also reserve the
            right to bill any other credit card or alternative payment method
            you have used in the past for subscription billings to collect the
            outstanding balance of what you owe us prior to cancellation.
          </p>
          <h3>
            <span>Future Subscription Ban</span>
          </h3>
          <p>
            If your BerserkerMail subscription is cancelled, we reserve the
            unilateral right to ban you (for any reason or for no reason
            whatsoever) from subscribing to BerserkerMail again in the future.
          </p>
        </FollowingContent>
        <Acknowledge>
          <Checkbox
            size="lg"
            colorScheme="orange"
            css={css`
              .css-17f88hv[aria-checked="true"],
              .css-17f88hv[data-checked] {
                background: var(--chakra-colors-orange-50) !important;
                border-color: var(--chakra-colors-orange-50) !important;
              }
            `}
            isChecked={readCheck}
            onChange={() => setReadCheck(!readCheck)}
          >
            I have read and agree to the Terms & Conditions above
          </Checkbox>
          <Checkbox
            size="lg"
            colorScheme="orange"
            css={css`
              .css-17f88hv[aria-checked="true"],
              .css-17f88hv[data-checked] {
                background: var(--chakra-colors-orange-50) !important;
                border-color: var(--chakra-colors-orange-50) !important;
              }
            `}
            isChecked={noRefundCheck}
            onChange={() => setNoRefundCheck(!noRefundCheck)}
          >
            I understand I can cancel at any time but there are no refunds on
            this service
          </Checkbox>

          <Checkbox
            size="lg"
            colorScheme="orange"
            css={css`
              .css-17f88hv[aria-checked="true"],
              .css-17f88hv[data-checked] {
                background: var(--chakra-colors-orange-50) !important;
                border-color: var(--chakra-colors-orange-50) !important;
              }
            `}
            isChecked={allowCheck}
            onChange={() => setAllowCheck(!allowCheck)}
          >
            I authorize BerserkerMail to capture IP{" "}
            {ipAdrress !== "" && `(${ipAdrress}) `}address and log my answers
          </Checkbox>
        </Acknowledge>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          <div>
            <ClickHereButton
              href="https://bzerk.me/tosdown"
              download
              target="_blank"
            >
              Click here to download
            </ClickHereButton>
          </div>
          <StyledButton
            disable={!(readCheck && allowCheck && noRefundCheck)}
            // css={css`
            //   height: 46px;
            //   width: 210px;
            //   border-radius: 23px;
            //   margin-top: 30px;
            //   padding: 12px 21px;
            // `}
            onClick={onOkClick}
          >
            Continue to payment
          </StyledButton>
        </div>
      </FollowingWrapper>
    </ModalContainer>
  );
}
